const xle = "xle";
const limited = "limited";
const platinum = "platinum";

export const HotspotLocations = (displayMode) => {
  if (displayMode === "exterior") {
    return exteriorHotspotLocations;
  } else if (displayMode === "interior") {
    return interiorHotspotLocations;
  } else if (displayMode === "powertrain") {
    return powertrainHotspotLocations;
  }
};

export const clearSelectedHotspot = () => {
  exteriorHotspotLocations.forEach((hotspot) => {
    hotspot.selected = false;
  });
  interiorHotspotLocations.forEach((hotspot) => {
    hotspot.selected = false;
  });
  powertrainHotspotLocations.forEach((hotspot) => {
    hotspot.selected = false;
  });
};

export const exteriorHotspotLocations = [
  {
    id: 0,
    position: [-0.9, 0.6, 1.17],
    selected: false,
    switchSides: true,
    cat: [xle, limited, platinum],
    title: "All Wheel Drive (AWD)",
    body: "Advanced capability, standard. Toyota Crown’s standard All-Wheel Drive (AWD) system automatically supplies power to the rear wheels to help improve traction. When driving through less than perfect road conditions, the advanced system gives you the peace of mind to power through.",
  },
  {
    id: 1,
    position: [-0.9, 0.33, -1.4],
    target: [1.45, -0.45, 0.8],
    offset: [1.17, -0.21, 2.66],
    mobileOffset: [1.28, -0.37, 2.45],
    landscapeOffset: [1.29, -0.41, 1.8],
    minAzimuthAngle: -1.2,
    maxAzimuthAngle: 1.2,
    minPolarAngle: 1,
    maxPolarAngle: 1.75,
    cat: [limited],
    selected: false,
    switchSides: true,
    title: "Available 21” Premium Alloy Wheels",
    body: "For a sleek and sophisticated look, Limited’s Advanced Technology Package comes outfitted with 21-in. dark premium metallic wheels.",
  },
  {
    id: 2,
    position: [0, 0.2, 2.35],
    selected: false,
    switchSides: false,
    cat: [xle, limited, platinum],
    title: "Elevated Ride Height",
    body: "Toyota Crown's magnetic look is unlike anything you've seen before. With 5.8-in. of ground clearance, its elevated cabin sits higher than traditional sedans. And its sleek and aerodynamic shape gives Toyota Crown a look that immediately catches your eye.",
  },
  {
    id: 3,
    position: [0, 1.58, -0.5],
    cat: [limited, platinum],
    target: [0.39, 0.48, -0.16],
    mobileOffset: [1.8, 2.1, 1.3],
    offset: [1.32, 1.25, 1.07],
    minAzimuthAngle: -Infinity,
    maxAzimuthAngle: Infinity,
    minPolarAngle: 1,
    maxPolarAngle: 1.4,
    selected: false,
    switchSides: false,
    title: "Fixed Panoramic Roof",
    body: "By letting an abundance of natural light in from above the front and rear seats, Toyota Crown’s available fixed panoramic roof creates a spacious atmosphere inside the refined cabin.",
  },
  {
    id: 4,
    position: [-0.7, 0.85, 2.15],
    target: [-2, -0.1, 0.6], //[-2.1, -0.5, 0]
    offset: [-3.25, -0.14, 1.52], //[-3.03, 0.2, 2.097]{x: -3.2584586156770925, y: -0.14063537225380546, z: 1.5177188285837122}
    mobileOffset: [-4, -0.01, 1.2], //[-2.2, -0.1, 1.5]
    minAzimuthAngle: -2,
    maxAzimuthAngle: 0,
    minPolarAngle: 1,
    maxPolarAngle: 2,
    selected: false,
    switchSides: true,
    cat: [limited, platinum],
    title: "Quad LED Headlights",
    body: "Quad LED headlights—featuring three low-beam lights and one high-beam light—efficiently illuminate the road ahead of you and give Toyota Crown an impressive look.",
  },
  {
    id: 5,
    position: [0, 1.31, 0.65],
    selected: false,
    switchSides: false,
    cat: [xle, limited, platinum],
    disclaimer:
      "* Toyota Safety Sense™ effectiveness is dependent on many factors including road, weather and vehicle conditions. Drivers are responsible for their own safe driving. Always pay attention to your surroundings and drive safely. See Owner’s Manual for limitations.",
    title: "Toyota Safety Sense 3.0",
    body: "Toyota Safety Sense™*, or TSS, is a suite of active safety technologies and advanced driver assistance systems designed to help address three key areas of accident protection: preventing or mitigating frontal collisions, keeping vehicles within their lane, and enhancing road safety during nighttime driving.",
  },
  {
    id: 6,
    position: [0, 1.09, 1.8],
    selected: false,
    switchSides: false,
    cat: [platinum],
    disclaimer: "* Extra-Cost Color",
    title: "Available Bi-Tone Paint",
    body: "All the components of Toyota Crown Platinum's daring design work together to make one clear argument: This premium sedan was crafted to stand out. With an available bi-tone finish that extends from the hood to the rear, Toyota Crown Platinum commands attention on every occasion.",
  },
  {
    id: 7,
    position: [-0.82, 0.3, 0],
    target: [0, 0, 0],
    offset: [-4.57, 0.16, -3.59], // [4.29, 0.08, 3.93]
    mobileOffset: [-4.77, -0.24, -3.577], //[4.9, -0.24, 3.4]
    landscapeOffset: [-3.3, -0.18, -3.2],
    selected: false,
    switchSides: true,
    cat: [platinum],
    title: "Adaptive Variable Suspension",
    body: "Adaptive Variable Suspension (AVS) adjusts damping force based on ever-changing road conditions. Whether it be a large pothole or bump, the damping force is controlled at the area of absorber friction for refined riding comfort and confident handling.",
  },
  {
    id: 8,
    position: [-0.9, 0.33, -1.4],
    target: [1.45, -0.55, 0],
    offset: [1.17, -0.21, 2.66],
    mobileOffset: [1.28, -0.37, 2.45],
    landscapeOffset: [1.29, -0.41, 1.8],
    minAzimuthAngle: -0.34,
    maxAzimuthAngle: 0.34,
    minPolarAngle: 1.1,
    maxPolarAngle: 1.5,
    cat: [platinum],
    selected: false,
    switchSides: true,
    title: "21” Premium Alloy Wheels",
    body: "Strong and lightweight, Toyota Crown’s alloy wheels improve both handling and acceleration, and play a pivotal role in its striking silhouette. On Platinum, 21-in. machine-finished 10-spoke alloy wheels with black accents accentuate Toyota Crown’s sporty design.",
  },
];

export const interiorHotspotLocations = [
  {
    id: 0,
    position: [-9, -4.5, 30],
    selected: false,
    cat: [xle, limited, platinum],
    title: "12.3” Multi Information Display",
    body: "Quickly see all the information you need inside Toyota Crown’s gauge cluster. The fully customizable 12.3-in. digital MID gives you access to safety features, navigation, audio controls, and more, while helping you keep focused on the road ahead.",
  },
  {
    id: 1,
    position: [1, 1.5, 30],
    selected: false,
    cat: [xle, limited, platinum],
    title: "Driver Focused Cockpit",
    body: "Toyota Crown’s driver-focused cockpit creates an instinctual connection between driver and machine. The thoughtful placement of the control switches is designed to put everything drivers or passengers most commonly want within an arm’s reach.",
  },
  {
    id: 2,
    position: [2, -5, 30],
    selected: false,
    cat: [xle, limited, platinum],
    title: "12.3” Toyota Audio Media",
    body: "Toyota Crown’s 12.3-in. Audio Multimedia touchscreen can be interacted with through sight, touch and voice activation. Using the intelligent interface, you can see where you’re going with turn-by-turn directions, access multimedia functions, and connect your smartphone to enjoy your favorite apps, playlists and podcasts.",
  },
  {
    id: 3,
    position: [-2, -13.9, 30],
    selected: false,
    cat: [xle, limited, platinum],
    disclaimer:
      "* Wireless charging may not be compatible with all mobile phones, smart devices, tablets, e-readers, MP3/WMA players and like products.",
    title: "QI Wireless Charging",
    body: "With an intuitively placed vertical wireless charging deck in the center console, all you need to do is set your Qi-compatible device down and let the battery start charging up.*",
  },
  {
    id: 4,
    position: [-18, -25, 15],
    selected: false,
    cat: [xle],
    title: "Heated and Powered Front Seats",
    body: "Add more cozy to every drive. When the weather gets chilly, Toyota Crown’s heated front seats warm up with the touch of a button, while a standard 8-way power-adjustable driver’s seat helps you find your sweet spot of comfort.",
  },
  {
    id: 5,
    position: [-14, -12, 20],
    selected: false,
    cat: [limited, platinum],
    title: "Heated Steering Wheel",
    body: "With the press of a button, Toyota Crown’s heated steering wheel quickly warms up for elevated driving on cold commutes.",
  },
  {
    id: 6,
    position: [-16, -27, 15],
    selected: false,
    cat: [limited, platinum],
    title: "Heated and Ventilated Front Seats",
    body: "Heat up on winter mornings or cool down on a hot summer day. No matter the season, you can use Toyota Crown’s heated and ventilated front seats to make every drive feel just right.",
  },
  {
    id: 7,
    position: [10, -5.4, -30],
    selected: false,
    cat: [limited, platinum],
    title: "Rear Heated Seats",
    body: "Toyota Crown’s premium feel stretches back to the second row with available heated rear seats—providing maximum comfort for all riders.",
  },
  {
    id: 8,
    position: [20.5, -1, 25],
    selected: false,
    cat: [limited, platinum],
    disclaimer:
      "* JBL® is a registered trademark of Harman International Industries, Inc.",
    title: "JBL Premium Audio System",
    body: "Start your workday on a high note with Toyota Crown’s available 11-speaker, 800-watt JBL® * Premium Audio system. Including a newly designed subwoofer, this advanced system will make the soundtrack to your commute sound better than ever.",
  },
  {
    id: 9,
    position: [-5, -9, 25],
    selected: false,
    cat: [platinum],
    disclaimer:
      "* Digital Key function requires Remote Connect trial or subscription. Use only if aware of circumstances surrounding vehicle and it is legal and safe to do so (e.g., do not remotely start engine if vehicle is in an enclosed space or vehicle is occupied by a child). Remote Connect depends on factors outside of Toyota’s control, including an operative telematics device, a cellular connection, GPS signal, and the availability of a compatible wireless network, without which system functionality and availability may be limited or precluded. Digital Key also requires Bluetooth® connectivity. Service may vary by vehicle and region. Requires app download and registration/subscription after trial (if applicable). Terms of Use apply. Data charges may apply. Remote start/stop not available on manual transmission-equipped vehicles. Services subject to change at any time without notice. See usage precautions and service limitations in Toyota Owner’s Manual and at https://www.toyota.com/connected-services/ for additional details. To learn about Toyota's Connected Services data collection, use, sharing and retention practices, please visit https://www.toyota.com/privacyvts/.",
    title: "Digital Key Capability",
    body: "With a Remote Connect subscription*, this app lets your smartphone and smartwatch act like your key.  You can lock/unlock doors, heat up the cabin on cold winter mornings and even share your keys with a friend—all from inside the app.",
  },
  {
    id: 10,
    position: [0.2, -16.5, 15],
    selected: false,
    cat: [platinum],
    title: "Six Modes Drive",
    body: "Platinum grade comes standard with six drives modes that transform a vehicle’s character with just the press of a button. It includes NORMAL, ECO and SPORT but adds three drive modes: SPORT+ mode that provides an emphasis on steering response, flat cornering and a sense of stability, COMFORT mode that provides a more supple drive that emphasizes passenger comfort and a CUSTOM mode that enables drivers to adjust system settings individually, creating a safe profile that suites their driving habits.",
  },
  {
    id: 11,
    position: [1, -16, 25],
    selected: false,
    cat: [platinum],
    disclaimer:
      "* Do not overly rely on Advanced Park and use only in accordance with applicable laws. Remain attentive to surroundings. Before operating, review Owner’s Manual for instructions and limitations.",
    title: "Advanced Park",
    body: "Toyota Crown’s Advanced Park * makes fitting into a tight spot as simple as pressing a button. Just sit back, take your hands off the wheel and watch this advanced system work its magic.",
  },
  {
    id: 12,
    position: [-4, -15, 25],
    selected: false,
    cat: [platinum],
    disclaimer:
      "* The Panoramic View Monitor does not provide a comprehensive view of the area surrounding your vehicle. Look around to confirm clearance. See Owner’s Manual for limitations.",
    title: "Panoramic View Monitor",
    body: "Panoramic View Monitor (PVM) uses cameras on the front, sides and rear to give you a 360-degree view of what’s going on outside.",
  },
];

export const powertrainHotspotLocations = [
  {
    id: 0,
    position: [0, 1, 1.89],
    selected: false,
    cat: [xle, limited],
    title: "2.5L Engine",
    body: "The fourth-generation Toyota Hybrid System combines a high-efficiency 2.5-liter DOHC four-cylinder engine with two electric motors in a highly compact system. The gas engine employs Variable Valve Timing-intelligent by Electric motor (VVT-iE) on the intake camshaft, and VVT-i on the exhaust camshaft. The variable range for the valve timings of both the intake and exhaust are set to maximize both fuel consumption and output.",
  },
  {
    id: 1,
    position: [-0.35, 0.9, 1.6],
    selected: false,
    cat: [xle, limited],
    title: "Power Control Unit",
    body: "The Power Control Unit, with a more compact design, is installed directly above the transaxle, providing a small and lightweight Hybrid system.",
  },
  {
    id: 2,
    position: [0, 0.5, -0.7],
    selected: false,
    cat: [xle, limited, platinum],
    title: "Bipolar Nickel-Hydrogen Battery",
    body: "Newly developed bipolar nickel-hydrogen battery simplifies the design by reducing the number of parts; thus, making the battery more compact and capable of achieving twice the output of the conventional nickel-hydrogen battery.",
  },
  {
    id: 3,
    position: [-0.3, 0.4, 1.7],
    selected: false,
    cat: [xle, limited],
    title: "eCVT",
    body: "Electronically Controlled Continuously Variable Transmission.",
  },
  {
    id: 4,
    position: [0, 1, 1.89],
    selected: false,
    cat: [platinum],
    title: "2.4L Turbocharged Engine",
    body: "The all-new Hybrid Max powertrain combines a 2.4-liter inline 4-cylinder turbocharged engine with electric motors – generating an exceptional 340 combined net horsepower with 400 lb.-ft. of torque capable of accelerating 0-60mph in 5.7 seconds.",
  },
  {
    id: 5,
    position: [-0.1, 0.6, -1.15],
    selected: false,
    cat: [platinum],
    title: "eAxle",
    body: "A rear wheel eAxle that’s equipped with a high output water-cooled electric motor capable of 124 FT.-LB. of torque is combined with the hybrid engine to directly transmit force to all four wheels, ensuring a thrilling throttle response and linear acceleration throughout the power band.",
  },
  {
    id: 6,
    position: [-0.2, 0.4, 1.7],
    selected: false,
    cat: [platinum],
    title: "Front Motor",
    body: "A front electric motor capable of 215 LB.-FT. helps maximize torque production.",
  },
  {
    id: 7,
    position: [-0.4, 0.4, 1.7],
    selected: false,
    cat: [platinum],
    title: "Direct Shift-6AT",
    body: "The Direct Shift-6AT incorporates a new technology – hydraulic multiplate wet start clutch – that remove the need for a torque converter, providing high acceleration responsiveness and acceleration performance.",
  },
];
